import RandingStyle7 from "../../randing/RandingStyle7";

function Randing192({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle7
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/192/01.jpg`}
      img4Path={`${process.env.REACT_APP_CDN_BASE}/images/192/q1.jpg`} //질문 이미지
      img5Path={`${process.env.REACT_APP_CDN_BASE}/images/192/q2.jpg`} //질문 이미지
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/blue/applyButton2.png`}
      qOptionImgPath={`${process.env.REACT_APP_CDN_BASE}/images/192`} // 필수!
      qOptions={["1-2개", "3-4개", "5개 이상", "상담 필요"]}
      formFieldColor="white"
      colorRequest="white"
      companyName="춘천청춘플란트"
      addStyle={{ marginTop: 0, width: "117.5%" }}
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/cheongchun.jpg`}
      kakaotalk="003"
      carrotTag={true}
    />
  );
}

export default Randing192;
